<template>
  <transition :name="'bar-fade'" mode="out-in">
    <div class="hl_head plr search_fixed" v-show="$route.name === 'home' || $route.name === 'catalog'" id="topBar">
      
      <template v-if="!searchBar">
        <BackButton class="hl_head_back"/>
        <div class="hl_search">
          <img v-if="$store.getters.showCallingWaiterButton && $store.getters.contactlessMode" 
            :src="require('@/assets/img/ecommerce/call_waiter.png')" class="call_waiter_btn"
            @click="openCallWaiterModal"
          >
          <img v-if="$store.getters.searchWidget" 
            :src="require('@/assets/img/ecommerce/search_ico.svg')"
            @click="openSearch"
          >
        </div>
        <div class="hl_calendar" @click="openDateFilter()" v-if="$store.getters.outletSettings.delivery_type === 4">
          <svg
            :fill="$store.getters.filter.date.start !== null && $store.getters.filter.date.end !== null ? '#0084FF' : '#000000'"
            style="display: block; height: 24px; width: 24px;"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              d="M12,19a1,1,0,1,0-1-1A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-1-1A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-1-1A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-1-1A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,0,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-1-1A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,7,19Z"/>
          </svg>
        </div>
        <a @click="goHome" class="hl_title">{{ $store.getters.outlet.outlet.company }}</a>
        <router-link :to="{ name: 'receipt', params: { token: this.$store.getters.token }}" class="hl_basket_ico"
                     :class="{'hl_basket_none': basketCount < 1}"><i>{{ basketCount }}</i></router-link>
      </template>
    </div>
  </transition>
</template>

<script>
import '@/assets/css/slick.css'
import {SET_MODAL, SET_SELECTED_CATEGORY} from '@/store/mutations.type'
import BackButton from '@/components/ECommerce/Categories/BackButton'

export default {
    name: 'TopBar',
    components: {
      BackButton
    },
    watch: {
      '$route': {
        handler: function (route) {
          if ((route.name === 'receipt' || route.name === 'form') && this.$store.getters.modal.search) {
            this.$store.commit(SET_MODAL, {modal: 'search', status: false})
            this.$store.commit(SET_MODAL, {modal: 'searchFull', status: false})
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      openDateFilter() {
        this.$store.commit(SET_MODAL, {modal: 'datefilter', status: true})
      },
      openSearch() {
        this.$store.commit(SET_MODAL, {modal: 'search', status: true})
      },
      goHome() {
        if (this.$route.name !== 'home') {
          this.$router.push({name: 'home', params: {token: this.$store.getters.token}}).then(() => {
            this.$store.commit(SET_SELECTED_CATEGORY, null)
          })
        }
      },
      openCallWaiterModal() {
        this.$store.commit(SET_MODAL, {modal: 'callWaiter', status: true})
      },
    },
    computed: {
      basketCount() {
        let count = 0
        this.$store.getters.selectedProducts.map(el => count += (el.count || el.length || 1))
        return count
      }
    },
    data() {
      return {
        searchBar: false,
      }
    }
  }
</script>

<style scoped>
.bar-fade-leave-active {
  transition: opacity 0.45s ease;
}

.search_fixed {
  /*touch-action: none;*/
  /*-webkit-user-drag: none;*/
}

.call_waiter_btn {
  width: 25px;
  margin-right: 8px;    
}


</style>
